import { jsPDF } from "jspdf";
import formularioPatentePrimeroProvidencia from "../../../img/formularioPatentePrimeroProvidencia.jpg";
import formularioPatenteSegundoProvidencia from "../../../img/formularioPatenteSegundoProvidencia.jpg";
import formularioPatenteTerceroProvidencia from "../../../img/formularioPatenteTerceroProvidencia.jpg";

export const DocumentosPatenteProvidencia = (datosDocumentosPatente) => {
	let {
		nombre,
		rut,
		razon,
		rutEmpresa,
		actividadEspecifica,
		codigo1,
		giro1,
		codigo2,
		giro2,
		codigo3,
		giro3,
		...demas
	} = datosDocumentosPatente;

	/* PDF */
	const doc = new jsPDF({ format: "letter" });

	/* Primera Hoja */
	doc.addImage(formularioPatentePrimeroProvidencia, "JPEG", 0, 0, 210, 280);
	doc.setFont("arial");
	doc.setFontSize(12);
	doc.text(razon, 50, 191);
	doc.text(rutEmpresa, 50, 196);
	doc.text(razon, 50, 200);
	doc.text(nombre, 50, 213);
	doc.text(rut, 50, 218);

	/* Codigo Actividad y Giro Especifico */
	doc.setFontSize(10);
	doc.text(codigo1, 25, 156);
	doc.text(
		giro1.charAt(0).toUpperCase() + giro1.slice(1).toLowerCase(),
		67,
		156
	);
	doc.text(codigo2, 25, 161);
	doc.text(
		giro2.charAt(0).toUpperCase() + giro2.slice(1).toLowerCase(),
		67,
		161
	);
	doc.text(codigo3, 25, 165);
	doc.text(
		giro3.charAt(0).toUpperCase() + giro3.slice(1).toLowerCase(),
		67,
		165
	);
	doc.text(
		actividadEspecifica.charAt(0).toUpperCase() +
			actividadEspecifica.slice(1).toLowerCase(),
		70,
		145
	);

	/* Segunda Hoja */
	doc.addPage("letter");
	doc.addImage(formularioPatenteSegundoProvidencia, "JPEG", 0, 0, 210, 280);
	doc.setFont("arial");
	doc.setFontSize(14);

	/* Tercera Hoja */
	doc.addPage("letter");
	doc.addImage(formularioPatenteTerceroProvidencia, "JPEG", 0, 0, 210, 280);
	doc.setFont("arial");
	doc.setFontSize(12);
	doc.text(razon, 74, 52);
	doc.text(rutEmpresa, 74, 58);
	doc.text(nombre, 74, 64);
	doc.text(rut, 74, 70);
	doc.text("AV. NUEVA PROVIDENCIA 1945, OF 807, PROVIDENCIA", 74, 77);
	doc.text("+569 9532 5916", 74, 85);
	doc.text("patente@denegocios.cl", 74, 91);

	const fechaActual = new Date();
	const diaNumero = fechaActual.getDate().toString();
	const meses = [
		"Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
		"Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
	];
	const mesPalabra = meses[fechaActual.getMonth()];
	const ultimoDigitoAnio = fechaActual.getFullYear().toString().slice(-1);

	doc.text(diaNumero, 50, 255);
	doc.text(mesPalabra, 65, 255);
	doc.text(ultimoDigitoAnio, 105, 255);

	console.log (typeof diaNumero, typeof mesPalabra, typeof ultimoDigitoAnio);

	doc.save(`Documentos Patente Providencia para ${razon}.pdf`);
};
